var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/** @internal */
var ApplePaySdkService = /** @class */ (function () {
    function ApplePaySdkService(pspName) {
        var _this = this;
        this.handleResponse = function (response) { return __awaiter(_this, void 0, void 0, function () {
            var xRequestId, responseJson, responseModel;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        xRequestId = response.headers.get("X-REQUESTID");
                        return [4 /*yield*/, response.json()];
                    case 1:
                        responseJson = _a.sent();
                        responseModel = {
                            xRequestId: xRequestId ? xRequestId : undefined,
                            data: responseJson,
                        };
                        if (response.ok) {
                            return [2 /*return*/, Promise.resolve(responseModel)];
                        }
                        responseModel.error = "".concat(response.status, " ").concat(response.statusText);
                        return [2 /*return*/, Promise.reject(responseModel)];
                }
            });
        }); };
        this.validateMerchant = function (merchantIdentifier, displayName, initiativeContext) { return __awaiter(_this, void 0, void 0, function () {
            var validateMerchantRequest;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        validateMerchantRequest = {
                            merchantIdentifier: merchantIdentifier,
                            displayName: displayName,
                            initiativeContext: initiativeContext,
                        };
                        return [4 /*yield*/, fetch("".concat(this.baseUrl, "/validateMerchant"), {
                                method: "POST",
                                body: JSON.stringify(validateMerchantRequest),
                                headers: {
                                    "Content-Type": "application/json",
                                },
                            })
                                .then(function (response) { return _this.handleResponse(response); })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.completePayment = function (applePayPayment, transactionId) { return __awaiter(_this, void 0, void 0, function () {
            var billingContact, shippingContact, appleBillingContact, name_1, appleShippingContact, name_2, completePaymentRequest;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (applePayPayment.billingContact) {
                            appleBillingContact = applePayPayment.billingContact;
                            name_1 = "";
                            if (appleBillingContact.givenName && appleBillingContact.familyName)
                                name_1 = "".concat(appleBillingContact.givenName, " ").concat(appleBillingContact.familyName);
                            else if (appleBillingContact.givenName)
                                name_1 = appleBillingContact.givenName;
                            else if (appleBillingContact.familyName)
                                name_1 = appleBillingContact.familyName;
                            billingContact = {
                                city: appleBillingContact.locality,
                                countryCode: appleBillingContact.countryCode,
                                line1: appleBillingContact.addressLines
                                    ? appleBillingContact.addressLines.length > 0
                                        ? appleBillingContact.addressLines[0]
                                        : undefined
                                    : undefined,
                                line2: appleBillingContact.addressLines
                                    ? appleBillingContact.addressLines.length > 1
                                        ? appleBillingContact.addressLines[1]
                                        : undefined
                                    : undefined,
                                name: name_1,
                                phoneNumber: appleBillingContact.phoneNumber,
                                state: appleBillingContact.country,
                                zip: appleBillingContact.postalCode,
                            };
                        }
                        if (applePayPayment.shippingContact) {
                            appleShippingContact = applePayPayment.shippingContact;
                            name_2 = "";
                            if (appleShippingContact.givenName && appleShippingContact.familyName)
                                name_2 = "".concat(appleShippingContact.givenName, " ").concat(appleShippingContact.familyName);
                            else if (appleShippingContact.givenName)
                                name_2 = appleShippingContact.givenName;
                            else if (appleShippingContact.familyName)
                                name_2 = appleShippingContact.familyName;
                            shippingContact = {
                                city: appleShippingContact.locality,
                                countryCode: appleShippingContact.countryCode,
                                emailAddress: appleShippingContact.emailAddress,
                                line1: appleShippingContact.addressLines
                                    ? appleShippingContact.addressLines.length > 0
                                        ? appleShippingContact.addressLines[0]
                                        : undefined
                                    : undefined,
                                line2: appleShippingContact.addressLines
                                    ? appleShippingContact.addressLines.length > 1
                                        ? appleShippingContact.addressLines[1]
                                        : undefined
                                    : undefined,
                                name: name_2,
                                phoneNumber: appleShippingContact.phoneNumber,
                                state: appleShippingContact.country,
                                zip: appleShippingContact.postalCode,
                            };
                        }
                        completePaymentRequest = {
                            paymentToken: applePayPayment.token,
                            billingContact: billingContact,
                            shippingContact: shippingContact,
                            transactionId: transactionId,
                        };
                        return [4 /*yield*/, fetch("".concat(this.baseUrl, "/completePayment"), {
                                method: "POST",
                                body: JSON.stringify(completePaymentRequest),
                                headers: {
                                    "Content-Type": "application/json",
                                },
                            })
                                .then(function (response) { return _this.handleResponse(response); })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.baseUrl = "https://".concat(pspName, ".applepayecom.payair.com");
    }
    return ApplePaySdkService;
}());
export default ApplePaySdkService;
